<script>
import componentCustom  from './customComponent'
 export default {
    inheritAttrs: true,
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    components: {
        componentCustom
    },
    data() {
        return {
            classNames: 'searchForm',
            ruleForm: {}
        }
    },
    computed: {
        searchValue() {
            return (item) => {
                return item.prop
            }
        }
    },
    watch: {
        ruleForm: {
            deep: true,
            handler(news) {
                this.$emit('getForm', news)
            }
        }
    },
    render(h) {
        const classNames = this.classNames
        return (
            <div class={classNames}>
                <el-row gutter={20}>
                    {
                        this.data.map((item, index) => {
                            return <el-col span={ item.span || 6 } key={ index }>
                                <div class={ classNames + '_search_item' }>
                                    {item.label ? <span class={ classNames + '_search_item_title' }>{ item.label }</span>: ''}
                                    {item.beforeslot && item.beforeslot(h) }
                                    {
                                      
                                        <componentCustom  items={item} key={index} ruleForm={this.ruleForm}>
                                        {
                                            item.renderHTML && item.renderHTML(h) ? item.renderHTML(h) : item.childSlot ? item.childSlot.map((ele, i) => {
                                                return <componentCustom items={ele} key={ i }>
                                                    {ele.renderHTML && ele.renderHTML(h)}
                                                </componentCustom>
                                            }): ''
                                        }
                                        </componentCustom>
                                    }
                                    {item.afterslot && item.afterslot(h) }
                                </div>
                            </el-col>
                        })
                    }
                </el-row>
            </div>)
    }
 }
</script>
<style lang="less" scoped>
    @classNames: searchForm;
    .@{classNames} {
        .@{classNames}_search_item {
            display: flex;
            align-items: center;
            margin-right: 16px;
            margin-bottom: 12px;
            .@{classNames}_search_item_title {
                white-space: nowrap;
                font-size: 14px;
                color: #606266;
                margin-right: 12px;
            }
        }
    }
</style>
